import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IMetadataRegistryEntry } from "../../Orchestrator/Types/Interface/IMetadataRegistry";

/**
 * Flat key/value settings the backend owns. Every caller is a config read with
 * a working default, so a failure must stay silent: no error toast, no global
 * loader blocking the UI behind a value nobody is waiting on.
 *
 * Both are defaults, not guarantees: a backend apiConfig entry for this exact
 * path would override cacheMode and the loader flag (ApiRequest.ts). None
 * exists today — if one ever does, exclude the path rather than relying on it.
 */
export async function getMetadataRegistry(): Promise<IApiResponse<IMetadataRegistryEntry[]>> {
    const ENDPOINTS = await getEndpoints();
    return await apiRequest<IMetadataRegistryEntry[]>(
        ENDPOINTS.getMetadataRegistry,
        'GET',
        {},
        // No cache layer here: metadataRegistryCache memoises the payload for
        // the session and coalesces concurrent reads itself.
        "none",
        undefined,
        undefined,
        false, // showLoaderForThisRequest
        false, // showErrorToast
    );
}
